<template>
  <div class="pa-4">
    <v-row>
      <v-btn
        download
        href="/prirucka.pdf"
        color="blue-grey"
        class="ma-2 white--text"
      >
        Používateľská príručka eCRA
        <v-icon
          right
          dark
        >
          mdi-download
        </v-icon>
      </v-btn>
      <v-btn
        download
        href="/protokol.pdf"
        color="blue-grey"
        class="ma-2 white--text"
      >
        Protokol o odovzdaní a prevzatí zamestnaneckého diela
        <v-icon
          right
          dark
        >
          mdi-download
        </v-icon>
      </v-btn>
    </v-row>

    <v-row>
      <v-subheader>Otázky a chyby: juraj.petrik@zvjs.sk</v-subheader>
    </v-row>
    <v-row>
      <v-subheader>Kolektív národného projektu ŠNN@ZVJS</v-subheader>
    </v-row>
  </div>
</template>

<script>
export default {};
</script>
